import { motion } from 'framer-motion';
import V2_1 from '../../assets/images/home/vector2/vector2-1.svg';
import V2_2 from '../../assets/images/home/vector2/vector2-2.svg';
import V2_3 from '../../assets/images/home/vector2/vector2-3.svg';
import V2_4 from '../../assets/images/home/vector2/vector2-4.svg';
import V2_5 from '../../assets/images/home/vector2/vector2-5.svg';
import V2_6 from '../../assets/images/home/vector2/vector2-6.svg';
import V2_7 from '../../assets/images/home/vector2/vector2-7.svg';

const Vector2 = () => {
  return (
    <motion.div className="vector" id="vector2"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.5 }}
    >
      <img src={V2_1} alt="Décoration à droite" />
      <img src={V2_2} alt="Décoration à droite" />
      <img src={V2_3} alt="Décoration à droite" />
      <img src={V2_4} alt="Décoration à droite" />
      <img src={V2_5} alt="Décoration à droite" />
      <img src={V2_6} alt="Décoration à droite" />
      <img src={V2_7} alt="Décoration à droite" />
    </motion.div>
  );
};

export default Vector2;